import React from "react";
import { useDrop } from "react-dnd";
import CardComponent, { DraggedCard } from "./Card";
import ScrollableWrapper from "../common/ScrollableWrapper";
import useTheme from "../../../../common/hooks/useTheme";
import styled from "styled-components";
import { metricDataType } from "../../../../providers/dataPlatformReportTypes";

interface UnselectedContainerProps {
  cards: metricDataType[];
  onCardDrop: (draggedCard: DraggedCard) => void;
  type: string;
}

const UnselectedGrid = styled.div`
  border-radius: 8px;
  min-height: 100px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const UnselectedGridWrapper = styled.div`
  margin-right: -20px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
`;

const UnselectedContainer: React.FC<UnselectedContainerProps> = ({
  cards,
  onCardDrop,
  type,
}) => {
  const theme = useTheme();
  const [{ isOver }, dropRef] = useDrop({
    accept: "CARD",
    drop: (draggedCard: DraggedCard) => {
      if (draggedCard.fromSelected) {
        onCardDrop(draggedCard);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return (
    <UnselectedGridWrapper
      style={{
        backgroundColor: isOver ? theme.colorTokens.P[10] : "transparent",
      }}
    >
      <ScrollableWrapper>
        <UnselectedGrid ref={dropRef}>
          {cards.map((card, index) => (
            <CardComponent
              key={index}
              card={card}
              index={index}
              fromSelected={false}
              type={type}
            />
          ))}
        </UnselectedGrid>
      </ScrollableWrapper>
    </UnselectedGridWrapper>
  );
};

export default UnselectedContainer;
